export class OutputFlag {
	constructor(private name: string, private value: boolean) { }

	public getName(): string {
		return this.name;
	}
	public getValue(): boolean {
		return this.value;
	}
}

export class ClientOutput {
	public clientName: string;
	public advisorName: string;
	public firm: string;
	public outputFlags: OutputFlag[];
	public portfolioStrategist?: string;
	public uniqueID?: string;
	public coverPageFirm?: string;

	/**
	 * @param {string} clientName Client Name
	 * @param {string} advisorName Advisor Name
	 * @param {string} firm Advisor Firm
	 * @param {OutputFlag[]} outputFlags Custom flags can be passed in from here if needed
	 * @param {string} portfolioStrategist Name of PS Team Member who worked on this engagement
	 * @param {string} uniqueID PS Engagement ID
	 */
	constructor(clientName: string, advisorName: string, firm: string, outputFlags: OutputFlag[], portfolioStrategist?: string, uniqueID?: string, coverPageFirm?: string) {
		this.clientName = clientName ? clientName : '';
		this.advisorName = advisorName ? advisorName : '';
		this.firm = firm ? firm : '';
		this.outputFlags = outputFlags ? outputFlags : [];
		this.portfolioStrategist = portfolioStrategist ? portfolioStrategist : '';
		this.uniqueID = uniqueID ? uniqueID : '';
		this.coverPageFirm = coverPageFirm || '';
	}
}
